import { useTranslation } from 'react-i18next';
import { Drawer } from '@hump/ui';
import { useReaderStore } from '../../stores/reader';

export function ReadingSettings() {
  const { t } = useTranslation();
  const { settingsOpen, setSettingsOpen, settings, updateSettings } = useReaderStore();

  return (
    <Drawer open={settingsOpen} onClose={() => setSettingsOpen(false)} side="right" title={t('reader.settings')}>
      <div className="space-y-6">
        <div>
          <label className="block text-sm font-medium text-charcoal dark:text-charcoal-light mb-2">
            {t('reader.fontSize')}: {settings.fontSize}px
          </label>
          <input
            type="range"
            min={12}
            max={24}
            value={settings.fontSize}
            onChange={(e) => updateSettings({ fontSize: Number(e.target.value) })}
            className="w-full accent-camel"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-charcoal dark:text-charcoal-light mb-2">
            {t('reader.lineHeight')}: {settings.lineHeight.toFixed(1)}
          </label>
          <input
            type="range"
            min={1.2}
            max={2.4}
            step={0.1}
            value={settings.lineHeight}
            onChange={(e) => updateSettings({ lineHeight: Number(e.target.value) })}
            className="w-full accent-camel"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-charcoal dark:text-charcoal-light mb-2">
            {t('reader.theme')}
          </label>
          <div className="flex gap-2">
            {(['light', 'dark', 'sepia'] as const).map((theme) => (
              <button
                key={theme}
                onClick={() => updateSettings({ theme })}
                className={`px-3 py-1.5 rounded-md text-sm border transition-colors ${
                  settings.theme === theme
                    ? 'border-camel bg-camel/10 text-camel-dark dark:text-camel'
                    : 'border-border-warm dark:border-border-warm-dark text-charcoal/60 dark:text-charcoal-light/60'
                }`}
              >
                {t(`reader.theme${theme.charAt(0).toUpperCase() + theme.slice(1)}`)}
              </button>
            ))}
          </div>
        </div>
      </div>
    </Drawer>
  );
}
